// Scroll-reveal animation — port of app/components/RevealObserver.tsx
// Adds the `in` class to `.reveal` elements as they scroll into view.
(function () {
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  function scan(root) {
    var els = (root || document).querySelectorAll(".reveal:not(.in)");
    els.forEach(function (el, i) {
      el.style.transitionDelay = (i % 4) * 80 + "ms";
      io.observe(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { scan(document); });
  } else {
    scan(document);
  }

  // Re-scan sections injected/re-rendered by the theme editor so they still animate.
  document.addEventListener("shopify:section:load", function (e) {
    scan(e.target);
  });
})();
